import {
  SelfSeatingLayout,
  SelfSeatingLayoutObject,
  TableSelection,
} from "./selfSeatingApi";

export function tableKey(layoutId: number, tableId: string) {
  return `${layoutId}:${tableId}`;
}

export function getTables(layouts: SelfSeatingLayout[]) {
  return layouts.flatMap(layout =>
    layout.layout
      .filter(item => item.type === "table")
      .map(table => ({ layoutId: layout.id, table })),
  );
}

export function initialSelection(layouts: SelfSeatingLayout[]) {
  return new Set(
    getTables(layouts)
      .filter(({ table }) => table.selected)
      .map(({ layoutId, table }) => tableKey(layoutId, table.id)),
  );
}

export function selectedTables(
  layouts: SelfSeatingLayout[],
  selection: Set<string>,
) {
  return getTables(layouts).filter(({ layoutId, table }) =>
    selection.has(tableKey(layoutId, table.id)),
  );
}

export function selectedCapacity(
  layouts: SelfSeatingLayout[],
  selection: Set<string>,
) {
  return selectedTables(layouts, selection).reduce(
    (capacity, { table }) => capacity + (table.max_person || 0),
    0,
  );
}

export function canAddTable(
  layouts: SelfSeatingLayout[],
  selection: Set<string>,
  guestCount: number,
  candidate: SelfSeatingLayoutObject,
) {
  const capacities = [
    ...selectedTables(layouts, selection).map(
      ({ table }) => table.max_person || 0,
    ),
    candidate.max_person || 0,
  ];
  const totalCapacity = capacities.reduce(
    (total, capacity) => total + capacity,
    0,
  );

  if (selectedCapacity(layouts, selection) >= guestCount) {
    return false;
  }

  return !capacities.some(capacity => totalCapacity - capacity >= guestCount);
}

export function toSelectionPayload(
  layouts: SelfSeatingLayout[],
  selection: Set<string>,
): TableSelection[] {
  return selectedTables(layouts, selection).map(({ layoutId, table }) => ({
    layout_id: layoutId,
    table_id: table.id,
  }));
}
